import { render, staticRenderFns } from "./FormBannerSectorComponent.vue?vue&type=template&id=49b3a510&scoped=true"
import script from "./FormBannerSectorComponent.vue?vue&type=script&lang=js"
export * from "./FormBannerSectorComponent.vue?vue&type=script&lang=js"
import style0 from "./FormBannerSectorComponent.vue?vue&type=style&index=0&id=49b3a510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b3a510",
  null
  
)

export default component.exports